export default [
  { occupation: 'Teacher', salary: 40000 },
  { occupation: 'Doctor', salary: 160000 },
  { occupation: 'Software Engineer', salary: 120000 },
  { occupation: 'Barista', salary: 36000 },
  { occupation: 'Other', salary: 0 },
]
